<div class="mat-dialog-cont mt-2">
  <div class="header">
    <strong>{{ 'BUTTONS.NEW_RECORD' | translate }}</strong>
    <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="mode-toggle">
    <button type="button"
      class="mode-btn"
      [class.mode-btn--active]="activeTab === 'manual'"
      (click)="activeTab = 'manual'">
      <img src="./assets/icon/manual.svg" alt="" />
      {{ 'BUTTONS.MANUAL_ENTRY' | translate }}
    </button>
    <button type="button"
      class="mode-btn"
      [class.mode-btn--active]="activeTab === 'upload'"
      (click)="activeTab = 'upload'">
      <img src="./assets/icon/file.svg" alt="" />
      {{ 'BUTTONS.UPLOAD_FILE' | translate }}
    </button>
  </div>

  @if (activeTab === 'upload') {
    <div>
      <div class="overflow-box" style="max-height: 500px; overflow: auto;">
        <div class="d-flex flex-column border">
          <div class="d-flex cursor-pointer pl-4">
            <div class="pl-4 flex-grow-1" (click)="sortTable('filename')">
              <strong>{{ 'FORM.FILE_NAME' | translate }}</strong>
              <img [src]="sortOrder ? './assets/icon/chevron-up.svg' : './assets/icon/chevron-down.svg'"
                [ngStyle]="{'width': '16px', 'height': '16px'}" />
              </div>
              <div class="pl-4 flex-grow-1" (click)="sortTable('date')">
                <strong>{{ 'FORM.DATE_AND_TIME' | translate }}</strong>
                <img [src]="sortOrder ? './assets/icon/chevron-up.svg' : './assets/icon/chevron-down.svg'"
                  [ngStyle]="{'width': '16px', 'height': '16px'}" />
                </div>
                <div class="pl-4 flex-grow-1" (click)="sortTable('note')">
                  <strong>{{ 'VIBRATION.NOTE' | translate }}</strong>
                  <img [src]="sortOrder ? './assets/icon/chevron-up.svg' : './assets/icon/chevron-down.svg'"
                    [ngStyle]="{'width': '16px', 'height': '16px'}" />
                  </div>
                  <div class="pl-4 flex-grow-1" (click)="sortTable('Maximum')">
                    <strong>{{ 'VIBRATION.MAX' | translate }}</strong>
                    <img [src]="sortOrder ? './assets/icon/chevron-up.svg' : './assets/icon/chevron-down.svg'"
                      [ngStyle]="{'width': '16px', 'height': '16px'}" />
                    </div>
                    <div class="pl-4 flex-grow-1" (click)="sortTable('devices')">
                      <strong>{{ 'FORM.DEVICES' | translate }}</strong>
                      <img [src]="sortOrder ? './assets/icon/chevron-up.svg' : './assets/icon/chevron-down.svg'"
                        [ngStyle]="{'width': '16px', 'height': '16px'}" />
                      </div>
                    </div>

                    <div class="drag-chart" [ngClass]="{'minigraph-bg': !vibrationsNewModelSelected}">
                      @for (record of allRecords; track record; let j = $index) {
                        <div class="border border-2 m-3 p-3 rounded">
                          <div class="d-flex cursor-pointer">
                            <div class="flex-grow-1" (click)="sortTable('filename')">
                              <img src="./assets/icon/report.svg" />
                              <strong class="colored-title">{{ record?.recordMetadata.fileName }}</strong>
                            </div>
                            <div class="flex-grow-1" (click)="sortTable('date')">
                              <span>{{ record?.recordMetadata.timestamp | date: 'dd/MM/yyyy':'UTC' }}</span><br />
                              <span>{{ record?.recordMetadata.timestamp | date: 'HH:mm:ss':'UTC' }}</span>
                            </div>
                            <div class="flex-grow-1" (click)="sortTable('note')">
                              <span>{{ record?.recordMetadata.note1 }}</span>
                            </div>
                            <div class="flex-grow-1" (click)="sortTable('Maximum')">
                              <div class="container">
                                <div class="row">
                                  @for (data of record?.signalDataEntity?.signalData?.channels; track data; let i = $index) {
                                    <div
                                      class="col">
                                      <div>
                                        <span class="text-muted">C{{ i + 1 }}</span><br />
                                        {{ findMaxAbsValue(data.timeSpectrum.ppvMin, data.timeSpectrum.ppvMax) | number: '1.2-2' }}
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="ps-4 flex-grow-1" (click)="sortTable('devices')">
                              <img src="./assets/icon/device.svg" />
                              <span class="ps-1">{{ record?.recordMetadata.seismographSerialNumber }}</span>
                            </div>
                          </div>
                          <hr />
                          <div class="charts">
                            @for (a of record?.signalDataEntity?.signalData?.channels; track a; let i = $index) {
                              <div
                                [ngClass]="record?.signalDataEntity?.signalData?.channels.length > 3 ? 'col-3' : 'col-4'">
                                <canvas class="canvas-custom-width" id="canvas-{{j}}-{{i}}" height="70vh"></canvas>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                @if (isLoading) {
                  <div class="progress ml-2 mr-2" style="height: 12px;">
                    <div class="progress-bar" role="progressbar" [ngStyle]="{'width': barValue}" aria-valuenow="5" aria-valuemin="0" aria-valuemax="100">{{barValue}}</div>
                  </div>
                }
                <div class="m-4 drag-drop-area d-flex justify-content-center"
                  (drop)="onFileDrop($event)"
                  (dragover)="onDragOver($event)">
                  <div class="text-center">
                    <input type="file" id="fileInput" class="file-input" multiple (change)="onFileInputChange($event)" #fileInput>
                    <label for="fileInput" class="custom-file-lab colored-title p-2">
                      {{ 'MESSAGE_INFO.UPLOAD_RECORD' | translate }}
                    </label>
                    <p>{{ 'MESSAGE_INFO.ACCEPTED_FILE_FORMATS' | translate }}: sis, csv (Up to 5Mo).</p>
                  </div>
                </div>

                <div class="button-group p-3">
                  <button class="btn btn-secondary" (click)="closeDialog()">{{ 'BUTTONS.CANCEL' | translate }}</button>
                  <button class="btn btn-primary" (click)="confirm()">{{ 'BUTTONS.CONFIRM' | translate }}</button>
                </div>
              </div>
  }

  @if (activeTab === 'manual') {
    <form [formGroup]="manualForm" (ngSubmit)="submitManualRecord()" class="manual-form p-4 row">

      <div class="form-group mb-3 col-6">
        <label for="controlPointId">{{ 'VIBRATION.CONTROL_POINT' | translate }}</label>
        <ng-select
          id="controlPointId"
          formControlName="controlPointId"
          [items]="controlPoints"
          bindValue="controlPointId"
          bindLabel="name"
          [searchable]="true"
          [clearable]="false"
          placeholder="{{ 'VIBRATION.SELECT_CONTROL_POINT' | translate }}">
          <ng-template ng-label-tmp let-item="item">
            {{ item.name }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.name }}
          </ng-template>
        </ng-select>
        @if (manualForm.get('controlPointId')?.invalid && manualForm.get('controlPointId')?.touched) {
          <div class="text-danger small mt-1">{{ 'FORM.FIELD_REQUIRED' | translate }}</div>
        }
      </div>

      <div class="form-group mb-3 col-6">
        <label for="distance">{{ 'VIBRATION.DISTANCE' | translate }}</label>
        <input
          id="distance"
          type="number"
          class="form-control"
          formControlName="distance"
          min="0"
          placeholder="e.g. 100" />
        @if (manualForm.get('distance')?.invalid && manualForm.get('distance')?.touched) {
          <div class="text-danger small mt-1">{{ 'FORM.REQUIRED_POSITIVE_NUMBER' | translate }}</div>
        }
      </div>

      <div class="form-group mb-3 col-6">
        <label for="overpressure">{{ 'VIBRATION.OVERPRESSURE' | translate }}</label>
        <input
          id="overpressure"
          type="number"
          class="form-control"
          formControlName="overpressure"
          min="0"
          step="0.01"
          placeholder="e.g. 1.5" />
        @if (manualForm.get('overpressure')?.invalid && manualForm.get('overpressure')?.touched) {
          <div class="text-danger small mt-1">{{ 'FORM.REQUIRED_POSITIVE_NUMBER' | translate }}</div>
        }
      </div>

      <div class="form-group mb-3 col-6">
        <label for="pic">{{ 'VIBRATION.PIC' | translate }}</label>
        <input
          id="pic"
          type="number"
          class="form-control"
          formControlName="pic"
          min="0"
          step="0.01"
          placeholder="e.g. 2.3" />
        @if (manualForm.get('pic')?.invalid && manualForm.get('pic')?.touched) {
          <div class="text-danger small mt-1">{{ 'FORM.REQUIRED_POSITIVE_NUMBER' | translate }}</div>
        }
      </div>

      <div class="button-group p-3">
        <button type="button" class="btn btn-secondary" (click)="closeDialog()">{{ 'BUTTONS.CANCEL' | translate }}</button>
        <button type="submit" class="btn btn-primary" [disabled]="isManualSubmitting">
          @if (isManualSubmitting) {
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          }
          {{ 'BUTTONS.CREATE_RECORD' | translate }}
        </button>
      </div>

    </form>
  }

</div>